import React from "react";
import Iframe from "./iframe";
import { FaMapMarkerAlt, FaPhoneAlt, FaClock, FaFacebook } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export const EMAIL = "champawatisaving@gmail.com";

const Contact = () => {
	return (
		<section className='sec' id='contact'>
			<div className='container'>
				<h2 className='sec-title'>Contact Us</h2>
				<div className='ct-grid'>
					<div className='ct-card'>
						<div className='panel-head'>Main Office</div>
						<ul className='ct-list'>
							<li>
								<FaMapMarkerAlt />
								<span>Machhapokhari, Kathmandu-16</span>
							</li>
							<li>
								<FaPhoneAlt />
								<span>
									<a href='tel:015906224'>01-5906224</a>,{" "}
									<a href='tel:9851279532'>9851279532</a>
								</span>
							</li>
							<li>
								<MdEmail />
								<a href={`mailto:${EMAIL}`}>{EMAIL}</a>
							</li>
							<li>
								<FaClock />
								<span>
									Sunday to Friday, 10am to 5pm
									<br />
									<small>(सार्वजनिक बिदा बाहेक)</small>
								</span>
							</li>
						</ul>
						<div className='ct-foot'>
							<a
								href='https://www.facebook.com/champawati.saving'
								target='_blank'
								rel='noopener noreferrer'
								className='btn-link'
							>
								<FaFacebook /> Facebook page
							</a>
						</div>
					</div>
					<div className='ct-map'>
						<Iframe />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
